import React from 'react';
import { useSelector } from 'react-redux';
import OfficeSurgeons from './OfficeSurgeons/OfficeSurgeons';
import HospitalSurgeonsPage from './HospitalSurgeons/HospitalSurgeonsPage';
import { UserProfileHasARoleSelector } from '@store/selectors/UserProfileSelector';
import { OfficeRoles } from '@interfaces/UserProfile/UserRoleEnum';
import { SurgeonContextProvider } from './SurgeonContext/SurgeonContext';

export default function Surgeons() {
	const isOfficeRole = useSelector(UserProfileHasARoleSelector(OfficeRoles));
	const surgeonsForRole = isOfficeRole ? <OfficeSurgeons /> : <HospitalSurgeonsPage />;
	return (
		<SurgeonContextProvider>
			{ surgeonsForRole }
		</SurgeonContextProvider>
	);
}
